
import { axiosInstance } from "@/lib/axiosInstance";
import config from "@/lib/config";
import axios from "axios";

export async function updateSubCategory(
  _id: string,
  updatedSubCategory: any
): Promise<any> {
  try {
    const response = await axiosInstance.patch(
      `${config.apiUrl}/sub-categories/${_id}`,
      updatedSubCategory
    );
    return response.data.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw new Error(
        error.response?.data.message || "Error updating Sub Category"
      );
    } else {
      throw new Error("An unknown error occurred");
    }
  }
}
